export const iconFontAwesomeShoppingShirt = (
	<i className="fa-solid fa-shirt"></i>
);
